import { useState, useEffect } from 'react';
import '../../SideBar/sidebar.scss';
import SideBarLogo from '../../../assets/images/sidebar-logo.svg';
import LogoIcon from '../../../assets/images/sidebar-logo-icon.svg';
// import DashboardIcon from '../../../assets/images/dashboard.svg';
// import CampaignIcon from '../../../assets/images/campaigns.svg';
import SettingsIcon from '../../../assets/images/settings.svg';
// import SupportIcon from '../../../assets/images/supporticon.svg';
// import NotificationIcon from '../../../assets/images/notificationicon.svg';
import LogoutIcon from '../../../assets/images/logout.svg';
import { Navbar, Nav } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { useApolloClient, useLazyQuery } from '@apollo/client';
import { GET_PROFILE } from '../../../gql/auth/queries';
import { IMAGE_URL } from '../../../configUrl';

const SideBar = ({ history }) => {
    const client = useApolloClient()
    const [fName, setFName] = useState('')
    // eslint-disable-next-line
    const [errorMessage, setErrorMessage] = useState('')

    const [loadUser, { data: profileData }] = useLazyQuery(GET_PROFILE, {
        onCompleted(data) {
            setFName(data?.me?.firstName)
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    });

    useEffect(() => {
        loadUser()
        // eslint-disable-next-line
    }, [])

    const getTitleColor = (curr) => {
        if (history.location.pathname === curr) {
            return "#fff"
        }
        if (window.location.href.indexOf(curr) > -1) {
            return "#fff"
        }
    }

    const getBackgroundColor = (curr) => {
        if (history.location.pathname === curr) {
            return "#226ef6"
        }
        if (window.location.href.indexOf(curr) > -1) {
            return "#226ef6"
        }
    }

    const getIconOpacity = (curr) => {
        if (history.location.pathname === curr) {
            return "1"
        }
        if (window.location.href.indexOf(curr) > -1) {
            return "1"
        }
    }

    // const preventRedirection = (e) => {
    //     e.preventDefault();
    // }

    const handleLogout = async () => {
        try {
            await client.resetStore()
            await client.cache.reset()
            localStorage.removeItem('token')
            localStorage.removeItem('refreshtoken')
            localStorage.removeItem('user')
            history.push('/')
        }
        catch (error) {
            await client.cache.reset()
            localStorage.removeItem('token')
            localStorage.removeItem('refreshtoken')
            localStorage.removeItem('user')
            history.push('/')
            console.error(error)
        }

    }

    return (
        <>
            <Navbar expand={false}>
                <div className="logo-wrapper">
                    <Navbar.Brand>
                        <img className="sidebar-logo" src={SideBarLogo} alt="Logo" />
                        <img className="sidebar-icon" src={LogoIcon} alt="Logo" />
                    </Navbar.Brand>
                </div>
                <Nav>
                    {/* <Link onClick={preventRedirection} className='nav-link' to="/admin-dashboard" style={{ color: getTitleColor('/admin-dashboard'), background: getBackgroundColor('/admin-dashboard') }}>
                        <img src={DashboardIcon} alt="Dashboard" style={{ opacity: getIconOpacity('/admin-dashboard') }} />
                        <span>Dashboard</span>
                    </Link>
                    <Link onClick={preventRedirection} className='nav-link' to="/#" style={{ color: getTitleColor('/roles'), background: getBackgroundColor('/roles') }}>
                        <img src={CampaignIcon} alt="Roles" style={{ opacity: getIconOpacity('/roles') }} />
                        <span>Roles</span>
                    </Link>
                    <Link onClick={preventRedirection} to="/#" className='nav-link' style={{ color: getTitleColor('/modules'), background: getBackgroundColor('/modules') }}>
                        <img src={SettingsIcon} alt="Modules" style={{ opacity: getIconOpacity('/modules') }} />
                        <span>Modules</span>
                    </Link>
                    <Link onClick={preventRedirection} to="/#" className='nav-link' style={{ color: getTitleColor('/permissions'), background: getBackgroundColor('/permissions') }}>
                        <img src={SettingsIcon} alt="Permissions" style={{ opacity: getIconOpacity('/permissions') }} />
                        <span>Permissions</span>
                    </Link> */}

                    <Link to="/admin-settings" className='nav-link' style={{ color: getTitleColor('/admin-settings'), background: getBackgroundColor('/admin-settings') }}>
                        <img src={SettingsIcon} alt="Admin-Settings" style={{ opacity: getIconOpacity('/admin-settings') }} />
                        <span>Admin Settings</span>
                    </Link>
                </Nav>
            </Navbar>
            {/* <Navbar className='bottom-menu' expand={false}>
                <Nav>
                    <Link onClick={preventRedirection} className='nav-link' to="/#">
                        <img src={NotificationIcon} alt="Notification" />
                        <span>Notification</span>
                    </Link>
                    <Link onClick={preventRedirection} className='nav-link' to="/#">
                        <img src={SupportIcon} alt="Support" />
                        <span>Support</span>
                    </Link>
                </Nav>
            </Navbar> */}
            <div className='profile-logout'>
                <ul>
                    <li>
                        <div className='profile-icon'>
                            {/* Add if else condition here, if image is there image tag else first letter of first name */}
                            {/* B */}
                            {
                                profileData && profileData?.me?.profileImage ?
                                    <img src={IMAGE_URL + profileData.me.profileImage} alt="pImage" />
                                    :
                                    fName && fName[0]
                            }
                            {/* <img src="" alt=""/> */}
                        </div>
                        <span>{profileData && profileData?.me && profileData.me?.firstName}</span>
                    </li>
                    <li>
                        <button onClick={handleLogout}>
                            <img src={LogoutIcon} alt="Campaigns" />
                            <span>Logout</span>
                        </button>
                    </li>
                    {/* <li>
              <button>
                <img src="" alt="" />
                <span>Log Out</span>
              </button>
            </li> */}
                </ul>
            </div>
        </>
    )
}

export default withRouter(SideBar);
